import React, { FC, useContext } from 'react'
import { Button, Form } from '@connectcore/connect-components-react'
import { ALIGN_BUTTONS_AND_LINKS } from '~utils/featureFlags'
import { GO_TO_LOGIN_BUTTON_LABEL } from '~utils/constants'
import { useHistory, useLocation } from 'react-router-dom'
import { IUserContextType, UserContext } from '~utils/context/UserContext'

const RetrieveChangePasswordSuccess: FC = () => {
  const { setStep, setIsLoading } = useContext(UserContext) as IUserContextType
  const history = useHistory()
  const token = useLocation()?.state?.storeToken

  const gotoLogin = () => {
    setIsLoading(true)
    setStep(undefined)
    history.push({
      pathname: '/',
      state: { storeToken: token },
    })
  }

  return (
    <Form
      onSubmit={() => gotoLogin()}
      className="wide-form"
      data-testid="RetrieveChangePasswordSuccess"
    >
      <h2 className="fw-bold">Account Profile</h2>
      <br />
      <p>Your password has been updated successfully. You can now login using your new password.</p>
      <div className="d-flex flex-column">
        <Button kind="primary" className={`my-3 align-${ALIGN_BUTTONS_AND_LINKS}`}>
          {GO_TO_LOGIN_BUTTON_LABEL}
        </Button>
      </div>
    </Form>
  )
}

export default RetrieveChangePasswordSuccess
